var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"main-heading__heading"},_vm._l((_vm.texts),function(ref,i){
var text = ref.text;
var to = ref.to;
return _c('span',{key:i,staticClass:"main-heading__heading_text"},[(!!to)?_c('router-link',{attrs:{"to":to}},[_vm._v(_vm._s(text))]):[_vm._v(_vm._s(text))]],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }